import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from './api';
import { clearUserData, getNewStateByAttr, getNewStateById } from './entities';
const initialState = {
    accept: {
        failures: [],
        successes: []
    },
    byId: {},
    byUsername: {},
    status: 'init',
    usernames: []
};
export const acceptFriendsRequests = createAsyncThunk('friendsRequests/accept', async (usernames, thunkApi) => {
    try {
        return await (await api.instance).acceptFriendsRequests({ usernames });
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const fetchFriendsRequests = createAsyncThunk('friendsRequests/fetch', async (usernames, thunkApi) => {
    try {
        return await (await api.instance).fetchFriendsRequests();
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const rejectFriendsRequest = createAsyncThunk('friendsRequests/reject', async (userId, thunkApi) => {
    try {
        return await (await api.instance).rejectFriendsRequests(userId);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
function isSubmittingAction(action) {
    return [acceptFriendsRequests.pending.type, acceptFriendsRequests.pending.type].includes(action.type);
}
function isRejectedAction(action) {
    return action.type.startsWith('friendsRequests/') && action.type.endsWith('/rejected');
}
const friendsRequestsSlice = createSlice({
    name: 'friendsRequests',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(clearUserData.fulfilled, (state) => (state = initialState))
            .addCase(acceptFriendsRequests.fulfilled, (state, action) => {
            state.accept = action.payload;
            state.status = 'success';
        })
            .addCase(fetchFriendsRequests.fulfilled, (state, action) => {
            state.byId = getNewStateById({}, action.payload);
            state.byUsername = getNewStateByAttr(state.byId, 'username');
            state.usernames = Object.keys(state.byUsername);
            state.status = 'success';
        })
            .addCase(rejectFriendsRequest.fulfilled, (state) => {
            state.status = 'success';
        })
            .addCase(fetchFriendsRequests.pending, (state) => {
            state.status = 'fetching';
        })
            .addMatcher(isSubmittingAction, (state) => {
            state.status = 'submitting';
        })
            .addMatcher(isRejectedAction, (state) => {
            state.status = 'error';
        });
    }
});
export const friendsRequestsReducer = friendsRequestsSlice.reducer;
